import { render, staticRenderFns } from "./txPairInfo.vue?vue&type=template&id=70affa46&scoped=true&"
import script from "./txPairInfo.vue?vue&type=script&lang=js&"
export * from "./txPairInfo.vue?vue&type=script&lang=js&"
import style0 from "./txPairInfo.vue?vue&type=style&index=0&id=70affa46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70affa46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70affa46')) {
      api.createRecord('70affa46', component.options)
    } else {
      api.reload('70affa46', component.options)
    }
    module.hot.accept("./txPairInfo.vue?vue&type=template&id=70affa46&scoped=true&", function () {
      api.rerender('70affa46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/head/txPairInfo.vue"
export default component.exports